
<form [formGroup]="form" (ngSubmit)="onContinue()" class="form full__height">
  <article class="small__padBot">
    <div class="mainInfo" *ngIf="!isEmbedded && mode !== 'modal'">
      <i class="mainIcon mainIcon--amount">
        <svg width="68" height="55" viewBox="0 0 68 55" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path class="svgPath--primary" d="M27.1125 0C12.2444 0 0 12.2444 0 27.1125C0 41.9807 12.2444 54.2251 27.1125 54.2251C42.1994 54.2251 54.2251 41.9807 54.2251 27.1125C54.2251 12.2444 42.1994 0 27.1125 0ZM27.1125 49.8521C14.6495 49.8521 4.37299 39.7942 4.37299 27.1125C4.37299 14.6495 14.4309 4.37299 27.1125 4.37299C39.5756 4.37299 49.8521 14.4309 49.8521 27.1125C49.8521 39.7942 39.7942 49.8521 27.1125 49.8521Z" fill="#000"/>
          <path class="svgPath--primary" d="M24.9261 20.3344H33.8908C35.2027 20.3344 36.0773 19.2411 36.0773 18.1479C36.0773 16.836 34.984 15.9614 33.8908 15.9614H29.2991V13.7749C29.2991 12.463 28.2059 11.5884 27.1126 11.5884C25.8007 11.5884 24.9261 12.6816 24.9261 13.7749V15.9614C21.2091 15.9614 18.148 19.0225 18.148 22.7395C18.148 26.4566 21.2091 29.5177 24.9261 29.5177H29.5178C30.8297 29.5177 31.7043 30.6109 31.7043 31.7042C31.7043 33.0161 30.611 33.8907 29.5178 33.8907H20.3345C19.0226 33.8907 18.148 34.9839 18.148 36.0771C18.148 37.1704 19.2413 38.2636 20.3345 38.2636H24.9261V40.4501C24.9261 41.762 26.0194 42.6366 27.1126 42.6366C28.4245 42.6366 29.2991 41.5434 29.2991 40.4501V38.2636C33.0162 38.2636 36.0773 35.2025 36.0773 31.4855C36.0773 27.7685 33.0162 24.7074 29.2991 24.7074H24.7075C23.3956 24.7074 22.521 23.6141 22.521 22.5209C22.7397 21.4276 23.6143 20.3344 24.9261 20.3344Z" fill="#000"/>
          <path class="svgPath--secondary" d="M63.4081 40.8875H55.7554C53.5689 45.2605 50.5078 49.1962 46.7908 52.2573H63.4081C65.8133 52.2573 67.9998 50.2894 67.9998 47.6656V45.4791C67.9998 42.8553 66.0319 40.8875 63.4081 40.8875Z" fill="#000"/>
          <path class="svgPath--secondary" d="M63.4081 27.1126H58.8165C58.8165 31.0483 57.9419 34.984 56.63 38.4824H63.1895C65.5946 38.4824 67.7811 36.5145 67.7811 33.8907V31.7042C67.9998 29.2991 66.0319 27.1126 63.4081 27.1126Z" fill="#000"/>
          <path class="svgPath--secondary" d="M63.4084 13.5563H55.7556C57.5048 17.0547 58.3794 20.7717 58.8167 24.9261H63.4084C65.8135 24.9261 68 22.9582 68 20.3344V18.1479C68 15.5241 66.0322 13.5563 63.4084 13.5563Z" fill="#000"/>
        </svg>
      </i>
      <h1 class="h1--bg">Simulación</h1>
    </div>

    <div class="simulationBox">
      <div class="simulationBox__content">
        <div class="form__group">
          <div class="subtitle subtitle--row subtitle--alignLeft">
            <h2>¿Cúanto dinero necesitas?</h2>
            <div class="amountBox"><span>{{selectedPrice | currency: country.currency:'symbol':'1.0-0'}}</span></div>
          </div>

          <div class="rangeSelectionBox">
            <div class="rangeSelectionBox__item rangeSelectionBox__item--smallPad">
              <p-slider [(ngModel)]="selectedPrice" [step]="50" [min]="minPrice()" [max]="maxPrice()" (onSlideEnd)="onParameterChange($event.value)" [ngModelOptions]="{standalone: true}"></p-slider>

              <div class="rangeSelectionBox__ref">
                <span>{{minPrice() | currency: country.currency:'symbol':'1.0-0'}}</span>
                <span>{{maxPrice() |  currency: country.currency:'symbol':'1.0-0'}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="form__group">
          <div class="subtitle subtitle--row subtitle--alignLeft">
            <h2>¿A qué plazo puedes pagarlo?</h2>
          </div>
          <div class="selectionQuota mt-15">
            <button *ngFor="let day of dayOptions" type="button"
                    (click)="onDayChange(day)" [ngClass]="selectedDay === day ? 'quota-btn selected' : 'quota-btn'" >
              <div class="text"><p> {{ day / 15 }}</p> <span *ngIf="day === selectedDay "> Quincenales</span> </div>
            </button>
          </div>
        </div>

        <!-- SIMULATION RESULTS CARD -->
        <div class="form__group">
          <div class="simulationResumeBox__summary" *ngIf="simulationsResults() && simulationsResults().quota_from">
            <div class="simulationResumeBox__summaryCont">
              <ul class="simulationResumeBox__summaryItems">
                <li class="simulationResumeBox__summaryItem highlight"><p><span class="title">Monto Solicitado</span><span class="value">{{ selectedPrice | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Cuota quincenal</span><span class="value">{{ simulationsResults().quota_from | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Próximo pago</span><span class="value">{{ simulationsResults().first_payment_date | date: 'dd/MM/yyyy' }}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total a pagar</span><span class="value">{{ (simulationsResults().quota_from * (selectedDay / 15)) | currency: country.currency:'symbol':'1.0-0'}}</span></p></li>
                <li class="simulationResumeBox__summaryItem"><p><span class="title">Total cuotas</span><span class="value">{{ selectedDay / 15 }} cuotas Quincenales</span></p></li>
              </ul>
            </div>
          </div>
          <div class="refText">
            <p>* Sujeto a politicas de aprobación</p>
          </div>
        </div>
        <div class="form__group" *ngIf="isEmbedded">
          <div class="iframe-button-content">
            <button pButton pRipple type="button" (click)="onContinueIframe()" [label]="simulationsResults() && simulationsResults().quota_from ? 'Continuar' : 'Simular'" icon="pi pi-angle-right" iconPos="right" class="p-button-secondary p-button-raised p-button-rounded w-full"></button>
          </div>
        </div>
      </div>
    </div>
  </article>

  <footer  *ngIf="!isEmbedded">
    <div class="footer__content">
      <!-- Button for normal mode -->
      <button pButton pRipple type="submit" [ngClass]="mode === 'modal' ? 'no-icon' : ''" [label]="mode === 'modal' ? 'Guardar' : (simulationsResults() && simulationsResults().quota_from ? 'Continuar' : 'Simular')" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full"></button>
    </div>
  </footer>
</form>
<!-- RESULT -->


